import { render, staticRenderFns } from "./userCertificates.vue?vue&type=template&id=ec72837c"
import script from "./userCertificates.vue?vue&type=script&lang=js"
export * from "./userCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports